// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  SimulationSandbox,
  SimulationSandboxT,
  verifySimulationSandbox,
} from "./simulation-sandbox";

export class SimulationSandboxList implements flatbuffers.IUnpackableObject<SimulationSandboxListT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationSandboxList {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationSandboxList(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationSandboxList,
  ): SimulationSandboxList {
    return (obj || new SimulationSandboxList()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimulationSandboxList(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationSandboxList,
  ): SimulationSandboxList {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationSandboxList()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  sandboxes(index: number, obj?: SimulationSandbox): SimulationSandbox | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new SimulationSandbox()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  sandboxesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startSimulationSandboxList(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addSandboxes(builder: flatbuffers.Builder, sandboxesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, sandboxesOffset, 0);
  }

  static createSandboxesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startSandboxesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endSimulationSandboxList(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSimulationSandboxList(
    builder: flatbuffers.Builder,
    sandboxesOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    SimulationSandboxList.startSimulationSandboxList(builder);
    SimulationSandboxList.addSandboxes(builder, sandboxesOffset);
    return SimulationSandboxList.endSimulationSandboxList(builder);
  }

  unpack(): SimulationSandboxListT {
    return new SimulationSandboxListT(
      this.bb!.createObjList<SimulationSandbox, SimulationSandboxT>(
        this.sandboxes.bind(this),
        this.sandboxesLength(),
      ),
    );
  }

  unpackTo(_o: SimulationSandboxListT): void {
    _o.sandboxes = this.bb!.createObjList<SimulationSandbox, SimulationSandboxT>(
      this.sandboxes.bind(this),
      this.sandboxesLength(),
    );
  }

  unpackFields(...fields: string[]): SimulationSandboxListT {
    const t = new SimulationSandboxListT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("sandboxes")) {
      t.sandboxes = this.bb!.createObjList<SimulationSandbox, SimulationSandboxT>(
        this.sandboxes.bind(this),
        this.sandboxesLength(),
      );
    }
    return t;
  }
}

export class SimulationSandboxListT implements flatbuffers.IGeneratedObject {
  constructor(public sandboxes: SimulationSandboxT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const sandboxes = SimulationSandboxList.createSandboxesVector(
      builder,
      builder.createObjectOffsetList(this.sandboxes),
    );

    return SimulationSandboxList.createSimulationSandboxList(builder, sandboxes);
  }

  clone(): SimulationSandboxListT {
    const obj = new SimulationSandboxListT();
    obj.sandboxes = this.sandboxes.map((e) => e.clone());
    return obj;
  }

  equals(other: SimulationSandboxListT): boolean {
    if (this.sandboxes.length !== other.sandboxes.length) return false;
    for (let i = 0; i < this.sandboxes.length; i++) {
      const a = this.sandboxes[i];
      const b = other.sandboxes[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifySimulationSandboxList(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifySimulationSandbox);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
